import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuoteForm from './components/QuoteForm';
import Gallery from './components/Gallery';
import Services from './components/Services';
import TRAVELTIPS from './components/TravelTips';
import Promotions from './components/Promotions';
import Testimonials from './components/Testimonials';
import Ratones from './components/Ratones';
import Calculator from './components/Calculator';
import FAQ from './components/FAQ';
import PayNowSection from './components/PayNowSection';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Login from './Login';
import Dashbord from './Dashbord';
import Tips from './Tips';
import Payment from './Payment';

function App() {
  return (
    <Router>
      <div className="overflow-x-hidden">
        <Navbar />
        
        <Routes>
          <Route 
            path="/" 
            element={
              <>
                <Hero />
                <QuoteForm />
                <Gallery />
                <Services />
                <TRAVELTIPS />
                <Testimonials />
                <Ratones />
                <Promotions />
                <PayNowSection />
                <FAQ />
                <Contact />
                <Footer />
              </>
            } 
          />
          <Route path="/tips" element={<Tips />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashbord />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;